<template>
  <div class="ws-breadcrumbs">
    <v-breadcrumbs
      class="pa-0"
      :items="items"
      :divider="divider"
    >
      <v-breadcrumbs-item
        slot="item"
        slot-scope="{ item }"
        exact
        :to="item.to"
        :disabled="item.disabled"
      >
        {{ item.text }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: null,
    },
    divider: {
      type: String,
      default: ">",
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-breadcrumbs.scss";
</style>